import axiosTelegramInstance from './axios.telegramInstance';
import axiosWcaInstance from './axios.wcaInstance';

export const apiRequest = async (method, url, data = null, params = null, component = 'wca') => {
  try {
    let instance;

    switch (component) {
      case 'telegram':
        instance = axiosTelegramInstance;
        break;

      case 'wca':
        instance = axiosWcaInstance;
        break;

      default:
        instance = axiosWcaInstance;
    }
    const config = {
      method,
      url,
      ...(data && method.toLowerCase() !== 'get' && { data }),
      ...(params && { params }),
    };
    const response = await instance(config);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};
